import { HomeIndex } from "./home/index";
import { UserHome } from "./user/home";
import { UserTrip } from "./user/trip";
import { AdminUsers } from "./admin/users";
import { annotateDebugComponents } from "../utils/dev_corner";
import UserProfile from "./user/profile";

export const AppRoutes = annotateDebugComponents([
  // public
  ["", HomeIndex, "Home"],
  // user
  ["/user", UserHome, "Home"],
  ["/user/trip/:id", UserTrip, "Trip"],
  ["/user/profile", UserProfile, "Profile"],
  // admin
  ["/admin", AdminUsers, "Admin"],
]);
